import HTTPClient from "../../services/AxiosClient";
import router from "../../routers";

HTTPClient.interceptors.response.use(function (response) {
    return response;
}, function (error) {

	const isNotLogout = error && error.response && error.response.config && error.response.config.url && error.response.config.url != "/auth/logout/";
	const isNotLogin = error && error.response && error.response.config && error.response.config.url && error.response.config.url != "/auth/login/";

	if (error && error.response && error.response.status == 401 && isNotLogout && isNotLogin) {
		router.push({ name: 'logout' });
	}

    return Promise.reject(error);
});

